import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import Select from "../../index";

import { ReactComponent as SortIcon } from "assets/icons/new/sort.svg";
import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

const Sort = ({ initial, options, forceBottom, onChange }) => {
  const { t } = useTranslation();

  const [innerSort, setInnerSort] = useState(
    options?.length > 0 && initial
      ? options.find((item) => item?.value === initial)
      : null,
  );

  if (!(options?.length > 0)) return null;

  return (
    <Select
      variant="sort"
      placeholder={{
        icon: <SortIcon />,
        label: t("Sort results"),
      }}
      options={options.map((item) => {
        const direction = item.value.split(":")[1];
        const isAsc = direction === "asc";

        return {
          ...item,
          variant: direction,
          icon: <ArrowIcon />,
          label: `${t(item.label)} - ${isAsc ? t("ascending") : t("descending")}`,
        };
      })}
      selected={innerSort}
      value={innerSort?.value}
      forceBottom={forceBottom}
      onChange={(option) => {
        setInnerSort(option);

        if (typeof onChange === "function") onChange(option);
      }}
    />
  );
};

export default Sort;
